import { AppDispatch, AppGetState } from "../store";
import config from "../config";
import { IBwaIoGateway } from "../io/ioGateway";

export const redirectToSigninPage = () => async (
  dispatch: AppDispatch,
  getState: AppGetState,
  { changeLocation, getLocation }: IBwaIoGateway,
): Promise<void> => {
  const referer = encodeURIComponent(getLocation());
  const loginServiceBaseUrl = encodeURIComponent(config.endpoints.loginService);
  const signinPageUrl = `${config.endpoints.loginPage}/?referer=${referer}&loginServiceBaseUrl=${loginServiceBaseUrl}`;
  changeLocation(signinPageUrl);
};
